/* eslint-disable no-useless-escape */
import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import { STATES } from './ZillowReviews/Component';
import Ratings from './Ratings';

function variableTranslation(translation = '', variableKey, replacementValue) {
  if (!(variableKey || replacementValue)) return translation;
  const regex = new RegExp(`\{${variableKey}\}`);
  return translation.replace(regex, replacementValue);
}

function TopReviews({ zillowData: { reviews }, staticContent, state }) {
  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      borderBottom: '1px solid rgb(232,232,232)'
    },
    description: {
      display: 'inline'
    },
    moreLink: {
      display: 'inline'
    },
    ending: {
      display: 'inline'
    },
    ratingContainer: {
      paddingVertical: 'small',
      paddingHorizontal: 'small'
    },
    rating: {
      display: 'flex'
    },
    ratingText: {
      paddingLeft: 'xxsmall'
    },
    ratingStars: {
      alignItems: 'center'
    }
  };

  const toNumStr = numVal => {
    if (Number.isInteger(numVal)) return numVal + '.0';
    return numVal.toString();
  };

  return (
    <UX2.Element.Block style={ styles.container }>
      { state === STATES.LOADED &&
        reviews.slice(0, 3).map((review, index) => {
          const rating = parseFloat(review.rating);
          return (
            <UX2.Element.Block style={ styles.ratingContainer } key={ `review-${index}` }>
              <UX2.Element.Block>
                <UX2.Element.Text style={ styles.description } children={ `"${review.description}` } />
                <UX2.Element.Link
                  target='_blank'
                  style={ styles.moreLink }
                  href={ review.reviewURL }
                  children={ ` ${staticContent.more}` }
                />
                <UX2.Element.Text style={ styles.ending } children={ '"' } />
              </UX2.Element.Block>
              <UX2.Element.Block style={ styles.rating }>
                <Ratings
                  rating={ rating }
                  starWidth='14'
                  starColor='rgb(107,182,34)'
                  style={ styles.ratingStars }
                />
                <UX2.Element.Text style={ styles.ratingText } children={ `${toNumStr(rating)}/5.0` } />
              </UX2.Element.Block>
              <UX2.Element.Details
                children={ variableTranslation(
                  staticContent.reviewAuthor,
                  'author',
                  review.reviewer
                ) }
              />
            </UX2.Element.Block>
          );
        }) }
    </UX2.Element.Block>
  );
}

TopReviews.propTypes = {
  zillowData: PropTypes.object,
  staticContent: PropTypes.object,
  state: PropTypes.string
};

export default TopReviews;
